module.exports = __webpack_public_path__ + "assets/img/star.a14d74f5.svg";